import React, { useEffect, useState, useRef } from "react";
import { Row, Col } from "antd";

import "./index.css";
import SingleTransactionCard from "./cards/TransactionCard";
import useAxiosPost from "../../../hooks/useAxiosPost";
import { useParams } from "react-router-dom";
import NetwalaPagination from "../../Items/Pagination/NetwalaPagination";
import TailSpinLoader from "../../Items/Loaders/TailSpinLoader";
import NetwalaSelect from "../../Items/Select/Index";
const UserTransactionsComponent = () => {
  const [getConnectionsApi, connectionsApiResponse] =
    useAxiosPost<GetUserProfileApiProp>(
      "connections/getConnectionsByUserIdWithMiniDetails"
    );
  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<GetUserTransactionsByIdApiProp>(
    "transactions/getMyUserTransactions"
  );
  const [transactions, setTransactions] = useState<TransactionHeadDetails[]>(
    []
  );
  const [selectedConnection, setSelectedConnection] = useState<string>("");
  const [connections, setConnections] = useState<NetwalaSelectOptions[]>([
    {
      label: "All",
      value: "",
    },
  ]);
  const [staff, setStaffProfile] = useState<StaffListType | null>(null);
  const [getStaffProfile, staffProfileApiResponse] =
    useAxiosPost<ResponseProp>("auth/getMyProfile");
  useEffect(() => {
    if (staffProfileApiResponse !== null) {
      const data: any = staffProfileApiResponse.responseData;
      setStaffProfile(data);
    }
  }, [staffProfileApiResponse]);

  const [pageSize, setPageSize] = useState<number>(50);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pagination, setPagination] = useState<PaginationProp>({
    totalPages: 0,
    currentPage: 1,
    previousPage: null,
    nextPage: null,
    totalCount: 0,
    pageSize: 50,
  });

  const { intPkHeadID } = useParams();
  useEffect(() => {
    if (apiResponse !== null) {
      const data: any = apiResponse.responseData;
      const {
        currentPage: apiCurrentPage,
        nextPage,
        pageSize: responsePageSize,
        previousPage,
        totalCount,
        totalPages,
        transactions,
      } = data;
      setPagination({
        currentPage: apiCurrentPage,
        totalPages,
        nextPage,
        previousPage,
        totalCount,
        pageSize: responsePageSize,
      });
      setTransactions(transactions || []);
      // Don't update state from API response - we control that from user actions
    }
  }, [apiResponse]);

  useEffect(() => {
    if (connectionsApiResponse !== null) {
      const data: any = connectionsApiResponse.responseData;
      const connections: any = [
        {
          label: "All",
          value: "",
        },
      ];
      data.map((item: any) => {
        if (item.connectionType === "INTERNET") {
          connections.push({
            label: item.username,
            value: item.intPkConnectionID,
          });
        } else if (item.connectionType === "CATV") {
          connections.push({
            label: `${item.firstName} ${item.lastName} - ${item.address}`,
            value: item.intPkConnectionID,
          });
        }
      });
      setConnections(connections);
    }
  }, [connectionsApiResponse]);

  // Track previous filter values to detect filter changes (not page/pageSize changes)
  const prevFiltersRef = useRef({
    selectedConnection,
  });

  useEffect(() => {
    // Check if filters changed (excluding page and pageSize changes)
    const filtersChanged =
      prevFiltersRef.current.selectedConnection !== selectedConnection;

    // If filters changed, reset to page 1
    if (filtersChanged) {
      setCurrentPage(1);
    }

    postApiData({
      intPkHeadID: Number(intPkHeadID),
      page: filtersChanged ? 1 : currentPage,
      intPkConnectionID: selectedConnection ? Number(selectedConnection) : null,
      pageSize,
    });

    // Update previous filter values
    prevFiltersRef.current = {
      selectedConnection,
    };
  }, [intPkHeadID, selectedConnection, pageSize, currentPage]);

  useEffect(() => {
    getConnectionsApi({ userId: Number(intPkHeadID) });
    getStaffProfile({});
  }, [intPkHeadID]);

  const handlePageSwitch = (pageNumber: number) => {
    setCurrentPage(pageNumber);
    // useEffect will handle the API call
  };
  const handlePageSizeChange = (page: number, size: number) => {
    setPageSize(size);
    setCurrentPage(1);
    // useEffect will handle the API call
  };
  const reloadAPi = () => {
    if (selectedConnection === "") {
      postApiData({
        intPkHeadID: Number(intPkHeadID),
        page: pagination.currentPage,
        intPkConnectionID: null,
        pageSize,
      });
    } else {
      postApiData({
        intPkHeadID: Number(intPkHeadID),
        page: pagination.currentPage,
        intPkConnectionID: Number(selectedConnection),
        pageSize,
      });
    }
  };
  return (
    <>
      {/* <Row
        gutter={[32, 32]}
        style={{ width: "100%", marginBottom: "20px", marginTop: "20px" }}
      >
        <Col offset={18} span={6}>
          <span className="create-user-form-label">Choose Connection</span>
          <NetwalaSelect
            size="large"
            height="45px"
            options={connections}
            showSearch={true}
            value={selectedConnection}
            placeHolder="Choose Connection"
            onChange={(e) => setSelectedConnection(e)}
          />
        </Col>
      </Row> */}
      {apiLoading === true ? (
        <TailSpinLoader />
      ) : (
        <>
          <Row gutter={[16, 16]} className="end-user-profile-container">
            {transactions.map((item) => {
              return (
                <Col key={Math.random()} span={24}>
                  <SingleTransactionCard
                    key={Math.random()}
                    transaction={item}
                    staffHeadId={staff?.intPkHeadID || -1}
                    reloadApi={reloadAPi}
                  />
                </Col>
              );
            })}
          </Row>
          <Row style={{ width: "100%" }}>
            <Col
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "20px",
                marginBottom: "20px",
              }}
              span={24}
            >
              <NetwalaPagination
                pagination={pagination}
                handlePageSwitch={handlePageSwitch}
                handlePageSizeChange={handlePageSizeChange}
              />
            </Col>
          </Row>
        </>
      )}
    </>
  );
};
export default React.memo(UserTransactionsComponent);
